import Typography from '@material-ui/core/Typography';
import {NyLoader} from 'nyse-web-tools-common/lib/react';
import React from 'react';
import {useDispatch} from 'react-redux';
import {Redirect} from 'react-router';
import {useMount} from 'react-use';

import useRoute from '../hooks/useRoute.hook';
import useUser from '../hooks/useUser.hook';
import {
    exchangeSessionToken,
    getUser
} from '../stores/user/user.actions';
import {navigate} from '../utils/navigation';

export const LoginPage = () => {
    const route = useRoute();
    const user = useUser();
    const dispatch = useDispatch();
    const sessionToken =
        route.params.sessionToken || route.params.session;
    const routeError = (route.params.error || '').trim();
    const hasRouteError = routeError.length > 0;

    const navigateHome = (event?: React.MouseEvent<HTMLAnchorElement>) => {
        if (event) {
            event.preventDefault();
        }

        navigate('/');
    };

    React.useEffect(() => {
        if (!hasRouteError) {
            return;
        }

        const timerId = window.setTimeout(() => {
            navigate('/');
        }, 10000);

        return () => window.clearTimeout(timerId);
    }, [hasRouteError]);

    useMount(() => {
        if (user.isJwtValid || hasRouteError) {
            return;
        }

        if (sessionToken) {
            dispatch(exchangeSessionToken(sessionToken))
                .then(() => dispatch(getUser()))
                .catch(() => {
                    navigate('/');
                });
        } else {
            navigate('/sentinel/oauth/authorize-oidc');
        }
    });

    if (user.isJwtValid) {
        return <Redirect to='/' />;
    }

    if (hasRouteError) {
        return (
            <div className='text-center mt-2'>
                <Typography variant='h6'>Unable to complete login</Typography>
                <Typography variant='body2'>{routeError}</Typography>
                <Typography variant='body2'>
                    You will be redirected in 10 seconds, or{' '}
                    <a href='/' onClick={navigateHome}>
                        continue now
                    </a>
                    .
                </Typography>
            </div>
        );
    }

    return (
        <div className='text-center mt-2'>
            <Typography variant='h6'>
                {sessionToken ? 'Logging in...' : 'Redirecting...'}
            </Typography>
            <NyLoader show />
        </div>
    );
};
